<template>
  <layout>
    <core-view class="primary" fill-height>
      <v-container id="containerlogo">
        <v-banner elevation="8" width="100%" color="#fafafa" single-line sticky>
          <div class="text-center margin-top inline-block" id="titulo">
            <p>Office Line Brasil</p>
          </div>

          <v-img
            contain
            src="/img/icons/brasil.png"
            max-width="80px"
            max-height="80vh"
            width="100%"
            id="imgtitulo"
            class="inline-block"
          >
          </v-img>
        </v-banner>
        <v-img
          contain
          src="/img/LogoHD.png"
          max-width="300px"
          max-height="55vh"
          id="imgamendoim"
        />
        <v-banner height="100px" class="text-center" :single-line="singleLineBool">
        <div
          id="tituloapp"
          class="display-2 font-weight-hign inline-block white--text text-center"
        >
          Officeline Brasil
        </div>
        <v-icon class="icone" small color="white dark" dense>
          mdi-registered-trademark
        </v-icon>
      </v-banner>
      </v-container>

      <v-navigation-drawer
        app
        right
        stateless
        :value="true"
        :width="$_width"
        :color="$_background_color"
        :dark="$_isMobile"
      >
        <v-container justify-space-around align-center flex-column class='background'>
          <v-img
              contain
              src="/img/sol_varejo.png"
              max-height="15vh"
              width="100%"
              class='sol'
          />

          <v-btn 
            @click="irParaConfiguracoes"
            color="grey"
            icon
            absolute
            top
            right
            >
            <v-icon>mdi-cog-outline</v-icon>
          </v-btn>

          <div  v-if="$_isMobile">
            <div id='div-imagem'>
              <p class="text-center font-weight-bold">
              </p>
              <v-img
              contain
              src="/img/LogoHD.png"
              max-width="225px"
              max-height="80px"
              width="32vw"
              id="imgamendoim"
              />
            </div>
            <v-banner class="text-center font-weight-bold black--text">
              Officeline Brasil
              <v-icon x-small color="black dark" dense>
                mdi-registered-trademark
              </v-icon>
            </v-banner>
          </div>

          <div class='formulario-container'>
            <v-form
            ref="form"
            id="formulario"
            class="align-self-stretch"
            :disabled="loading"
            @submit.prevent="$_onSubmit"
            >

            <div v-if="nomeVendedorSelecionado" class="text-center mb-4 mt-n2 ">
              <span class="caption grey--text">Vendedor Selecionado:</span>
              <div class="subtitle-1 font-weight-bold blue--text text--darken-3">
                {{ nomeVendedorSelecionado }}
              </div>
            </div>

            <v-combobox
              v-model="model.idVendedor"
              :items="listaVendedores"
              :item-text="formatarVendedor"
              item-value="IdVendedor"
              label="Selecione o Vendedor"
              :disabled="loading"
              :loading="loadingList"
              :rules="[v => !!v || 'Vendedor é obrigatório']"
              id="input-codigo"
              @focus="$_imputFocus"
              @blur="$_imputBlur"
              light
              outlined
              dense
              hide-details="auto"
              class="mb-4"
              no-data-text="Nenhum vendedor encontrado"
              :return-object="false"
              attach
              rounded
            >
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title>
                  <span class="font-weight-bold blue--text">{{ item.IdVendedor }}</span> 
                  <span class="grey--text text--darken-2"> - {{ item.NomeVendedor }}</span>
                  <span class="grey--text text--darken-2"> - {{ formatarCPF(item.CPF) }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <template v-slot:selection="{ item }">
              <span v-if="typeof item === 'object'">
                {{ item.IdVendedor }} - {{ item.NomeVendedor }}
              </span>
              <span v-else>
                {{ item }} </span>
            </template>

          </v-combobox>

            <core-password-field
              label="Senha"
              :disabled="loading"
              type=text
              v-model="model.password"
              maxlength="20"
              id='input-password'
              @focus='$_imputFocus'
              @blur='$_imputBlur'
              light
            />

            <v-row class="my-0">
              <v-spacer />

              <v-btn
                rounded
                x-large
                type="submit"
                class="loginbtn rounded-r-1"
                :loading="loading"
                color="#4c6faf"
                :dark="$_isMobile"
                :style='cssBotao'
              >
                <v-icon left>mdi-login</v-icon>
                Entrar
              </v-btn>
            </v-row>
          </v-form>
          </div>
          <v-container class='bkg_container'>
            <v-img
              contain
              src="/img/Faixa_2.png"
              width="100%"
              class="plantstop animate"
              :style="hidePlant"
            />
            <v-img
              contain
              src="/img/Faixa_3.png"
              width="100%"
              class="plantsbottom animate"
              :style="hidePlant"
            />
            <div :style="hidePlant" class='empresa animate'>
              <p>{{empresa}}</p>
              <p>V172-150926-004-01</p>
            </div>
          </v-container>
        </v-container>
      </v-navigation-drawer>
    </core-view>
    
    <v-dialog v-model="dialogGPS" persistent max-width="400">
      <v-card>
        <v-card-title class="headline primary white--text text--darken-2" v-if="!excedeuTentativasGPS">
          <v-icon color="white darken-2" left>mdi-map-marker-alert</v-icon>
          Atenção
        </v-card-title>
        <v-card-title class="headline primary white--text text--darken-2" v-else>
          <v-icon color="white darken-2" left>mdi-alert</v-icon>
          Localização não encontrada
        </v-card-title>
        
        <v-card-text class="pt-3 body-1 black--text" v-if="!excedeuTentativasGPS">
          A localização é <b>obrigatória</b> para realizar o login.
          <br><br>
          Ative o GPS e clique no botão abaixo para reiniciar.
        </v-card-text>
        <v-card-text class="pt-3 body-1 black--text" v-else>
          Não conseguimos obter sua localização após algumas tentativas.
          <br><br>
          Deseja continuar mesmo assim? Algumas funcionalidades podem ser limitadas.
        </v-card-text>

        <v-card-actions class="d-flex flex-wrap justify-end">
          
          <template v-if="!excedeuTentativasGPS">
            <v-btn 
              color="primary" 
              class="white--text" 
              :loading="loadingGPS"
              @click="$_recarregarPagina"
            >
              Verificar Novamente
            </v-btn>
          </template>
          
          <template v-else>
            <v-btn 
              color="grey" 
              text 
              :loading="loadingGPS"
              class="mr-2 mb-2"
              @click="$_recarregarPagina"
            >
              Tentar Novamente
            </v-btn>
            
            <v-btn 
              color="primary" 
              class="white--text mb-2" 
              @click="$_continuarSemGPS"
            >
              Continuar sem localização
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </layout>
</template>

<script>
import { ROUTE_HOME } from '@/constants/ROUTES';
import SnackbarEvent from '@/events/SnackbarEvent';
import actionResolver from '@/mixins/actions-resolver';
import CoreView from '@/components/core/view/Index.vue';
import CorePasswordField from '@/components/core/password-field/Index.vue';
import { mapActions, mapGetters } from 'vuex';
import Layout from '@/layouts/base/Index.vue'
import { VENDEDOR_STORAGE } from '@/constants/STORAGE'
import db from '@/plugins/dexie';
import {SetupIsOnline } from '../../utils/isonline';

export default {
  name: 'ViewSignIn',

  components: {
    CoreView,
    CorePasswordField,
    Layout,
  },

  mixins: [
    actionResolver({
      $_loginVendedor: 'vendedor/login',
      $_loginLocal: 'auth/authenticateLocal',
      $_getId: 'vendedor/findByWebId',
    }),
  ],

  data() {
    return {
      excedeuTentativasGPS: false,
      appTitle: process.env.VUE_APP_PROJECT_NAME,
      appVersion: process.env.VUE_APP_VERSION || '1.0.0',

      loading: false,
      mobile: false,
      cssBotao: 'margin-bottom: 0vh;border-bottom: 0vh;right: 21%; width: 60%;',
      hidePlant: '',
      singleLineBool: false,
      listaVendedores: [],
      loadingList: false,

      model: {
        idVendedor: null,
        password: null,
      },

      errors: {},
      empresa: null,
      showEmpresa: false,

      onLine: navigator.onLine,
      dialogGPS: false,
      loadingGPS: false,
    };
  },

  computed: {
    ...mapGetters('vendedor', ['idVendedor']), 

    $_isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    $_width() {
      return this.$_isMobile ? window.screen.width : 512;
    },
    $_background_color() {
      return this.$_isMobile ? 'primary' : 'white';
    },
    $_btn_color() {
      return this.$_isMobile ? 'white' : 'primary';
    },
    nomeVendedorSelecionado() {
      if (!this.model.idVendedor) return null;

      const vendedor = this.listaVendedores.find(v => v.IdVendedor === this.model.idVendedor);
      
      return vendedor ? vendedor.NomeVendedor : null;
    },
  },

  methods: {
    ...mapActions({
      $_loginLocal: 'auth/authenticateLocal',
      $_getId: 'vendedor/findByWebId',
    }),

    irParaConfiguracoes() {
        this.$router.push( {name: 'config'} );
    },

    formatarCPF(cpf) {
      if (!cpf) return '';
      const v = cpf.toString().replace(/\D/g, '');
      
      if (v.length === 11) {
        return v.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      }
      
      return cpf;
    },

    $_continuarSemGPS() {
      this.dialogGPS = false;
      sessionStorage.setItem('gps_ignorado', 'true');
    },

    $_verificarGPSInicial() {
      // Se ele já escolheu continuar sem GPS nesta sessão, nem testa mais
      if (sessionStorage.getItem('gps_ignorado') === 'true') {
        return;
      }

      const lat = localStorage.getItem('msUtil_latitude');
      const lng = localStorage.getItem('msUtil_longitude');

      if (!lat || !lng) {
        let attempts = parseInt(sessionStorage.getItem('gps_prompt_count') || '0', 10);
        
        if (attempts >= 2) {
          this.excedeuTentativasGPS = true;
        }
        
        this.dialogGPS = true;
        this.$_checkLocationPermission();
      } else {
        sessionStorage.removeItem('gps_prompt_count');
      }
    },

    $_recarregarPagina() {
      this.loadingGPS = true;
      let attempts = parseInt(sessionStorage.getItem('gps_prompt_count') || '0', 10);
      sessionStorage.setItem('gps_prompt_count', attempts + 1);
      window.location.reload();
    },

    formatarVendedor(item) {
      if (!item || typeof item === 'string') return item;

      const id = item.IdVendedor;
      const nome = item.NomeVendedor;
      
      let cpf = item.CPF || '';
      if (cpf.length === 11) {
        cpf = cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      }

      return `${id} - ${cpf} - ${nome}`;
    },

    async $_carregarListaVendedores() {
      this.loadingList = true;
      try {
        const vendedores = await db.vendedor
          .orderBy('codigo') 
          .toArray();

        this.listaVendedores = vendedores.map(v => ({
            IdVendedor: v.codigo,
            NomeVendedor: v.nome,
            CPF: v.cpf || ''
        }));
        
      } catch (error) {
        // console.error("Erro ao carregar vendedores do Dexie:", error);

      } finally {
        this.loadingList = false;
      }
    },

    async $_getEmpresa() {
      try {
        const param = await db.parametro.limit(1).first();

        if (param && param.empresa) {
          this.empresa = param.empresa;
          this.showEmpresa = true;
        } else {
          this.showEmpresa = false;
          console.warn('Tabela parametro vazia ou sem campo empnome.');
        }
      } catch (e) {
        // console.error("Erro ao carregar empresa do Dexie:", e);
        this.showEmpresa = false;
      }
    },

    async $_loadLastUser() {
      const lastCode = localStorage.getItem('last_login_code');
      if (lastCode) {
        this.model.idVendedor = parseInt(lastCode);
      }

      try {
        const param = await db.parametro.limit(1).first();
        if (param && param.senhaatual) {
          this.model.password = param.senhaatual;
        }
      } catch (e) {
        console.error("Erro ao carregar a senha salva:", e);
      }
    },

    async $_onSubmit() {
      const idSelecionado = (this.model.idVendedor && typeof this.model.idVendedor === 'object')
          ? this.model.idVendedor.IdVendedor 
          : (this.model.idVendedor || 1);

      if (this.model.password === 'carga') {
        const usuarioCarga = {
            codigo: null,
            nome: 'ADMIN CARGA',
            senha: 'carga',
        };

        try {
          localStorage.setItem('last_login_code', idSelecionado);

          const param = await db.parametro.limit(1).first();
          
          const dadosAtualizacao = { 
            idvendedorlogado: null,
            senhaatual: this.model.password 
          };

          if (param) {
            await db.parametro.update(param.id, dadosAtualizacao);
          } else {
            await db.parametro.add(dadosAtualizacao);
          }

          await this.$_loginLocal(usuarioCarga); 
          this.$router.replace(ROUTE_HOME.path).catch(() => {});
        } catch (e) {
          console.error('Erro ao processar login de carga:', e);
        }
        return;
      }

      if (!this.$refs.form.validate()) return;

      this.loading = true;

      try {
        const vendedor = await db.vendedor.where({
          codigo: idSelecionado
        }).first();

        let senhaValida = false;

        if (vendedor) {
          const senhaDigitada = this.model.password || '';
          const senhaBanco = vendedor.senha || '';

          if (senhaDigitada === senhaBanco) {
            senhaValida = true;
          }
        }

        if (senhaValida) {
          localStorage.setItem('last_login_code', idSelecionado);

          if (vendedor.venidnuvem) {
            sessionStorage.setItem(VENDEDOR_STORAGE.venidnuvem, vendedor.venidnuvem);
          }
          
          const idRealParaSalvar = vendedor.idvendedor || vendedor.id || idSelecionado;

          try {
            const param = await db.parametro.limit(1).first();
            
            const dadosAtualizacao = { 
              idvendedorlogado: idRealParaSalvar,
              senhaatual: this.model.password
            };

            if (param) {
              await db.parametro.update(param.id, dadosAtualizacao);
            } else {
              await db.parametro.add(dadosAtualizacao);
            }
          } catch (errParam) {
            console.error("Erro ao salvar idvendedorlogado em parametro:", errParam);
          }

          await this.$_loginLocal(vendedor);
          
          this.$router.replace(ROUTE_HOME.path).catch(err => {
            if (err.name !== 'NavigationDuplicated' && !err.message.includes('Redirected')) {
                throw err;
            }
          });

        } else {
          document.dispatchEvent(
            new SnackbarEvent({
              message: 'Usuário ou Senha incorretos (Base Local)',
              color: 'error'
            }),
          );
        }
      } catch (err) {
        console.error("Erro no login local:", err);
        document.dispatchEvent(
            new SnackbarEvent({ message: 'Erro crítico ao acessar banco local', color: 'error' })
        );
      } finally {
        this.loading = false;
      }
    },

    $_checkLocationPermission() {
      if (!('geolocation' in navigator)) {
        let attempts = parseInt(sessionStorage.getItem('gps_prompt_count') || '0', 10);
        if (attempts >= 2) this.excedeuTentativasGPS = true;
        this.dialogGPS = true;
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          localStorage.setItem('msUtil_latitude', position.coords.latitude);
          localStorage.setItem('msUtil_longitude', position.coords.longitude);
          
          sessionStorage.removeItem('gps_prompt_count');
          this.dialogGPS = false; 
        },
        (error) => {
          console.warn('Falha ao obter GPS forçado (Index):', error.message);
          let attempts = parseInt(sessionStorage.getItem('gps_prompt_count') || '0', 10);
          
          if (attempts >= 2) {
            this.excedeuTentativasGPS = true;
          }
          this.dialogGPS = true;
        },
        { 
          enableHighAccuracy: true, 
          timeout: 30000,
          maximumAge: 10000
        }
      );
    },

    $_imputFocus() {
      setTimeout(() => {
        const els = document.querySelectorAll('.animate');
        els.forEach((element) => { element.classList.add('fade'); });
      }, 150);
    },

    $_imputBlur() {
      setTimeout(() => {
        const els = document.querySelectorAll('.animate');
        els.forEach((element) => { element.classList.remove('fade'); });                                                                                                               
      }, 150);
    },
  },

  async mounted() {
    SetupIsOnline();
    await this.$_getEmpresa();
    await this.$_loadLastUser();
    await this.$_carregarListaVendedores();
    this.$_verificarGPSInicial();
  }
};
</script>

<style scoped>
.background {
  background-color: #ffffff;
}

#containerlogo {
  padding: 0px;
  height: 100%;
  display: inline;
}

#titulo {
  float: right;
  padding: 5px;
}

#titulo p {
  margin-top: 0px;
  margin-bottom: 0px;
  text-align: center;
}

#imgamendoim {
  margin-left: auto;
  margin-right: auto;
  margin-top: 5%;
}

.icone {
  vertical-align: text-top;
  display: inline-block;
}

#tituloapp {
  display: inline-block;
  padding: 5px;
}

/* ===== FORMULARIO ===== */

#formulario {
  margin-top: 10vh;
  min-height: 61vh;
  max-width: 525px;
  margin-top: 1vh;
  padding: 0px;
  border: 0px;
  flex-grow: 1;
}

.formulario-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

#input-codigo {
  max-width: 525px;
}

#input-password {
  max-width: 525px;
}

.loginbtn {
  color: white !important;
}

/* Animações mantidas... */
@keyframes sobePlanta {
  0% { transform: translateY(150%); }
  100% { transform: translateY(0%); }
}

@keyframes sobePlantaTABLET {
  0% { transform: translateY(150%); }
  100% { transform: translateY(25%); }
}

@keyframes desceSol {
  0% { transform: translateY(-150%); }
  100% { transform: translateY(-15%); }
}

.sol {
  transform: translateY(-150%);
  animation: 1.2s desceSol 0.3s 1 forwards;
}

.plantstop {
  transform: translateY(150%);
  position: absolute;
  bottom: 40px;
  left: 0px;
}

.plantsbottom {
  transform: translateY(150%);
  position: absolute;
  bottom: 0px;
  left: 0px;
}

.empresa {
  transform: translateY(150%);
  position: absolute;
  bottom: 5px;
  padding: 0px 10px 0px 10px;
  left: 0px;
  color: white;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.animate {
  animation: 1.2s sobePlanta 0.3s 1 forwards;
  transition: opacity 0.9s;
}

.fade {
  opacity: 0;
}

.margin-top {
  margin-top: 14px
}

/deep/ .v-banner .v-banner_wrapper{
  border: none !important;
}
</style>